import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { FrameShape } from './Types'
import { addFrame, getByPosition } from './helpers'
import { TLShapeId } from '@tldraw/tldraw'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { Plus1 } from 'blaze-ui/icons/24'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

interface Props {
  id: TLShapeId
  supportsCaption?: boolean
}

export const AddPage = ({ id, supportsCaption = false }: Props) => {
  const editor = useEditor()
  const shape = editor.getShape<FrameShape>(id)
  const isSystemRedesignEnabled = useIsSystemRedesign()

  if (!shape) return null

  const handlePress = () => {
    addFrame(editor, supportsCaption, { position: shape.props.position + 1 })

    const newFrame = getByPosition(editor, shape.props.position + 1)

    if (!newFrame) {
      return
    }

    const newFrameBounds = editor.getShapePageBounds(newFrame)

    if (!newFrameBounds) {
      return
    }

    editor.zoomToBounds(newFrameBounds, undefined, { duration: 500, easing: (t) => t * (2 - t) })
    showToastMessage('New page created')
  }

  return (
    <Tooltip label="Add another image/video" placement="left">
      <IconButton
        variant="ghost"
        size="sm"
        icon={() => <Plus1 size={isSystemRedesignEnabled ? 16 : 20} />}
        aria-label="Add another image/video"
        onPress={handlePress}
      />
    </Tooltip>
  )
}
